import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ProjectSummaryGetCollectionResponse, ProjectSummaryGetCollection } from '../../api/dtos';

const getData = (response?: SWRResponse<ProjectSummaryGetCollectionResponse, ProjectSummaryGetCollectionResponse>) => {
    return response?.data?.projectSummaries
}
const getError = (response?: SWRResponse<ProjectSummaryGetCollectionResponse, ProjectSummaryGetCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ProjectSummaryGetCollectionResponse, ProjectSummaryGetCollectionResponse>) => ({});

const useProjectSummaries = (showArchivedStages: boolean, configuration?: SWRConfiguration<ProjectSummaryGetCollectionResponse, ProjectSummaryGetCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => new ProjectSummaryGetCollection({ showArchivedStages });
    }, [showArchivedStages])

    return useGet(request, { getData, getError }, configuration);
}

export default useProjectSummaries;